// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewTabs-Tab_cls1__1GCOt","cls2":"PaymentViewTabs-Tab_cls2__h82um PaymentViewTabs-Tab_cls1__1GCOt"};